var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAlert',{staticClass:"tw-mt-2 tw-px-3 tw-py-3",attrs:{"theme":"danger"}},[_vm._v(" You are trying to request leave outside of the employment start/end date. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }